<template>
  <div id="contenedor-eliminar-cliente">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Cliente </v-card-title>
      <v-card-text>
        <template v-if="validoEliminar">
          <span class="secondary--text">
            ¿Desea eliminar al cliente "{{clienteEliminar.nombre}}"?
          </span>
        </template>
        <template v-else>
          <v-row>
            <span class="secondary--text">
              No se puede eliminar el cliente "{{clienteEliminar.nombre}}"
              por los siguientes motivos:
            </span>
          </v-row>
          <v-row class="my-2" v-if="getContratos">
            <span>
              - Tiene contratos registrados.
            </span>
          </v-row>
          <v-row v-if="!getUsuarios">
            <span>
              - Tiene usuarios registrados.
            </span>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          v-if="validoEliminar"
          @click="mixEliminarCliente"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoClientes from './mixCatalogoClientes';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosClienteEliminar',
  mixins: [mixCatalogoClientes],
  props: {
    clienteEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      cliente: {
        nombre: this.clienteEliminar.nombre,
        logo: this.clienteEliminar.logo,
      },
      date: '',
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },

  },
  computed: {
    validoEliminar() {
      if ((this.getContratos === false && this.getUsuarios === false)) { return true; }
      return false;
    },
    getContratos() {
      if (!this.contratos) return true;
      const contratos = this.contratos
        .filter((c) => c.idCliente === this.clienteEliminar.id);
      if (contratos.length > 0) { return true; }
      return false;
    },

    getUsuarios() {
      if (!this.usuarios) return true;
      const usuarios = this.usuarios
        .filter((u) => u.cliente?.id === this.clienteEliminar.id);
      if (usuarios.length > 0) { return true; }
      return false;
    },

  },
};
</script>

<style lang="scss">
</style>
